import React from "react";
import { Mail, Smartphone, X as XIcon } from "lucide-react";

// BazookaChannelTabs — the email/SMS/X tab toggle for ChairmansBazooka.
// Extracted from the parent (Iter-58.6 split) so the channel-switch UI
// is reusable from the same admin section in future surfaces (e.g.
// inline-row form, mobile sheet variant).
//
// Pure controlled component — parent owns `tab` + `setTab`. Each tab
// emits its own click handler so future analytics wiring can be done
// per-tab without touching the parent's `fire` logic.
export const TAB_EMAIL = "email";
export const TAB_SMS = "sms";
export const TAB_X = "x";

const TAB_DEFS = [
  { value: TAB_EMAIL, label: "Email", Icon: Mail, testId: "bazooka-tab-email" },
  { value: TAB_SMS, label: "SMS", Icon: Smartphone, testId: "bazooka-tab-sms" },
  { value: TAB_X, label: "X DM", Icon: XIcon, testId: "bazooka-tab-x" },
];

const BazookaChannelTabs = ({ tab, onChange }) => (
  <div className="flex gap-1 bg-gray-900/60 rounded-lg p-1 w-fit">
    {TAB_DEFS.map(({ value, label, Icon, testId }) => (
      <button
        key={value}
        type="button"
        onClick={() => onChange(value)}
        data-testid={testId}
        className={`px-3 py-1.5 rounded-md text-xs font-semibold inline-flex items-center gap-1.5 transition-colors ${
          tab === value ? "bg-amber-500 text-gray-900" : "text-gray-400 hover:text-gray-200"
        }`}
      >
        <Icon className="h-3.5 w-3.5" /> {label}
      </button>
    ))}
  </div>
);

export default BazookaChannelTabs;
